export default "__VITE_ASSET__CqxOYcI8__"